'use client';

import { useTranslations } from 'next-intl';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { alpha, useTheme } from '@mui/material/styles';

const questionKeys = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'] as const;

export function PainPointSection() {
  const t = useTranslations('creator.eventFaqBot.painPoints');
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        bgcolor: alpha(theme.palette.warning.main, 0.04),
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h4"
          component="h2"
          fontWeight={700}
          sx={{ mb: 1 }}
        >
          {t('title')}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          {t('subtitle')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            justifyContent: 'center',
          }}
        >
          {questionKeys.map((key) => (
            <Paper
              key={key}
              elevation={0}
              sx={{
                py: 1.5,
                px: 3,
                borderRadius: 6,
                bgcolor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
                fontSize: '0.95rem',
              }}
            >
              &ldquo;{t(key)}&rdquo;
            </Paper>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
